import React, { useState, useEffect, useContext, useRef } from "react";
import { API_KEY, imageUrl } from "../../Constants/Constance";
import axios from "../../axios";
import { PopUpContext } from "../../Context/moviePopUpContext";
import StarRatings from "react-star-ratings";
// import MoviePopUp from "../PopUp/MoviePopUp";
import usePlayMovie from "../../CustomHooks/usePlayMovie";
import axiosClient from "../../axios-client";
import usePlaySerie from "../../CustomHooks/usePlaySerie";
// import { VolumeUp, VolumeOff, VolumeDown } from "lucide-react"; // Using lucide-react for icons
import { FaVolumeUp, FaVolumeMute, FaVolumeDown } from "react-icons/fa"; // Import volume icons

import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AuthContext } from "../../Context/UserContext";
import { CgVolume } from "react-icons/cg";
import { AnimatePresence } from "framer-motion";
import ContentPopup from "../Popup/ContentPopup";
import SeriePopup from "../Popup/SeriePopup";
function Banner() {
  // const { showModal, setShowModal } = useContext(PopUpContext);
  const { playMovie } = usePlayMovie();
  const { playSerie } = usePlaySerie();
  const [isLoading, setIsLoading] = useState(false);

  const [movie, setMovie] = useState([]);
  const [moviePopupInfo, setMoviePopupInfo] = useState({});
  const [urlId, setUrlId] = useState("");
  const { user, profileId, userCountryCode } = useContext(AuthContext);
  const [isHovered, setIsHovered] = useState(false);
  const modalRef = useRef(null);

  const [showModal, setShowModal] = useState(false);
  const [shouldPop, setshouldPop] = useState(true);
  function getWindowSize() {
    const { innerWidth: width } = window;
    return {
      width
    }
  }

  const [windowSeize, setWindowSeize] = useState(getWindowSize())
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        setShowModal(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [setShowModal]);
  useEffect(() => {
    setIsLoading(true);
    const fetchMovie = async () => {
      try {

        const response = await axiosClient.get(`content/random/?profile_id=${profileId}`);

        setMovie(response.data);
        setIsLoading(false);
      } catch (error) {
        // console.error("Error fetching the movie data:", error);
        setIsLoading(false);
      }
    };

    fetchMovie();
  }, []);

  const handleMoviePopup = (movieInfo) => {
    if (!isLoading && !userCountryCode) {
      // alert("Error: Impossible de déterminer votre emplacement.");
      toast.error(`Impossible de déterminer votre emplacement.`, {
        position: "top-right",
        autoClose: 3000,

      });
      return;
    }
    if (movieInfo?.pays_codes?.length > 0 && !movieInfo?.pays_codes?.includes(userCountryCode)) {
      toast.error(`Désolé, ce contenu n'est pas disponible dans votre pays.`, {
        position: "top-right",
        autoClose: 3000,

      });
      // alert("Désolé, ce film n'est pas disponible dans votre pays.");
      return;
    }
    setMoviePopupInfo(movieInfo);
    setShowModal(true);
  };
  useEffect(() => {


    function handleWindowResize() {
      setWindowSeize(getWindowSize())
    }

    window.addEventListener('resize', handleWindowResize)

  }, []);

  const handleFavoriteClick = async (content, title) => {

    if (content.isLiked) {
      // If already favorited, remove it
      try {
        const response = await axiosClient.delete(`favorites/delete/${profileId}/${content.id}/`);
        if (response.status === 204) {

          setMovie({ ...movie, isLiked: false });
        }
        toast.error(`${title} a été retiré de vos favoris.`, {
          position: "top-right",
          autoClose: 3000,

        });
      } catch (error) {
        // console.error('Error removing from favorites', error);
      }
    } else {
      // If not favorited, add it
      try {
        const response = await axiosClient.post('favorites/create/', {
          profile: profileId,
          content: content.id,
        });
        if (response.status === 201) {

          setMovie({ ...movie, isLiked: true });
        }
        toast.success(`${title} a été ajouté à vos favoris.`, {
          position: "top-right",
          autoClose: 3000,

        });
      } catch (error) {
        // console.error('Error adding to favorites', error);
      }
    }
  };
  const [volume, setVolume] = useState(0); // Start muted (0 = muted, 1 = full volume)
  const videoRef = useRef(null);
  const [isHoveredVid, setIsHoveredVid] = useState(false);
  // Function to toggle mute/unmute
  const toggleMute = () => {
    if (videoRef.current) {
      const newVolume = volume === 0 ? 1 : 0;
      videoRef.current.volume = newVolume;
      setVolume(newVolume);
    }
  };

  // Function to adjust volume
  const changeVolume = (event) => {
    const newVolume = parseFloat(event.target.value);
    if (videoRef.current) {
      videoRef.current.volume = newVolume;
    }
    setVolume(newVolume);
  };
  const [showFull, setShowFull] = useState(false);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  return (
    <>
      <div
        // style={{

        //   backgroundImage: ` url(${movie.image})`,
        // }}
        onMouseEnter={() => setIsHoveredVid(true)} // Set to true on hover
        onMouseLeave={() => setIsHoveredVid(false)} // Set to false when mouse leaves
        className=" min-h-[50rem] md:min-h-[45rem] mb-5 3xl:h-[50rem] py-5 bg-cover bg-center object-contain grid items-center relative"
      >
        <video
          ref={videoRef}
          poster={screenWidth < 500 ? movie.poster : movie.image}
          className="absolute top-0 left-0 bottom-0 w-full h-[50rem] md:h-[45rem] 3xl:h-[50rem]  object-cover"
          src={movie.trailerUrl} // Replace with the appropriate key for the video URL
          autoPlay
          controlsList="nodownload"
          muted={volume === 0}
          loop
        />
        {movie.trailerUrl && (
          <div
            className={`absolute bottom-3 z-20 right-3 flex items-center bg-black bg-opacity-20 rounded-full p-2 transition-opacity  duration-500 ${isHoveredVid ? 'opacity-100' : 'opacity-50 pointer-events-none'}`}
          >
            {/* Mute/Unmute Button */}
            <button onClick={toggleMute} className="text-white p-2">
              {volume === 0 ? (
                <FaVolumeMute className=" md:size-5" />
              ) : (
                <FaVolumeUp className=" md:size-5" />
              )}
            </button>


            {/* Volume Slider */}
            <input

              type="range"
              min="0"
              max="1"
              step="0.1"
              value={volume}
              onChange={changeVolume}
              className="w-24 h-1 ml-2"
            />
          </div>
        )}
        <div className="z-10 ml-2  mr-2 sm:mr-0 sm:ml-12 mt-[75%] sm:mt-52">
          {movie.title ? (
            <>
              <h1 className="text-white text-3xl font-semibold text-center mb-5 py-2 sm:text-left sm:text-5xl sm:border-l-8 pl-4 border-orange-400 md:text-6xl lg:w-2/3 xl:w-1/2 sm:font-bold drop-shadow-lg">
                {movie.title}
              </h1>
            </>
          ) : (
            <div className="grid justify-center sm:justify-start">
              <div className="animate-pulse w-72 ml-4 sm:ml-0 sm:w-96 py-5 mb-7 xl:py-7 xl:w-45rem bg-neutral-900 rounded-md"></div>
            </div>
          )}


          <div className="flex">

            <div className="ml-2 hidden sm:flex justify-center sm:justify-start">
              {movie.releaseDate ? (
                <h1 className="flex text-white text-base font-bold drop-shadow-lg">
                  {movie.releaseDate.split("-")[0]}
                </h1>
              ) : null}
            </div>
            {movie.id && (
              <h1 className="hidden sm:flex text-white px-2 bg-[#1e1e1e89] border-2 border-stone-600 rounded ml-2">
                HD
              </h1>
            )}
          </div>

          <div className="mt-3 mb-4">
            {movie.description ? (
              <h1 className="text-white text-xl drop-shadow-xl text-center sm:text-left w-full md:w-4/5 lg:w-8/12/2 lg:text-xl xl:w-5/12 2xl:text-2xl">
                {showFull ? movie.description : `${movie.description.slice(0, 150)}${movie.description.length > 150 ? "..." : ""}`}
                {movie.description.length > 150 && (
                  <button
                    onClick={() => setShowFull(!showFull)}
                    className="text-[18px] text-orange-400 ml-2 hover:underline"
                  >
                    {showFull ? "Voir moins" : "Voir plus"}
                  </button>
                )}
              </h1>
            ) : (
              <div className="grid justify-center md:justify-start">
                <div className="animate-pulse w-80 sm:w-40rem md:w-45rem py-1 mb-3 xl:w-70rem xl:py-2 bg-neutral-900 rounded-md"></div>
                <div className="animate-pulse w-80 sm:w-40rem md:w-45rem py-1 mb-3 xl:w-70rem xl:py-2 bg-neutral-900 rounded-md"></div>
                <div className="animate-pulse w-80 sm:w-40rem md:w-45rem py-1 mb-7 xl:w-70rem xl:py-2 bg-neutral-900 rounded-md"></div>
              </div>
            )}
          </div>

          <div className="flex justify-center sm:justify-start">
            {movie.id ? (
              <>
                <button
                  onClick={() => movie.type === "series" ? playSerie(movie) : playMovie(movie)}
                  className="mb-12 bg-teal-400 hover:bg-orange-400 transition duration-500 ease-in-out shadow-2xl flex items-center  mr-3 text-base sm:text-xl font-semibold text-white py-2 sm:py-2 px-5 sm:px-8 rounded-md"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="w-6 h-6 mr-2 "
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M5.25 5.653c0-.856.917-1.398 1.667-.986l11.54 6.348a1.125 1.125 0 010 1.971l-11.54 6.347a1.125 1.125 0 01-1.667-.985V5.653z"
                    />
                  </svg>
                  {movie.type !== "series" ?
                    (Object.keys(movie?.watchHistory).length > 0 && !movie?.watchHistory?.isFinished) ? "Continuer" : "Regarder"
                    : "Regarder"}
                </button>
                <button onClick={() =>
                  handleMoviePopup(movie)
                } className="mr-3 bg-neutral-900 flex items-center shadow-2xl mb-12 text-base sm:text-xl font-semibold text-neutral-400 transition duration-500 ease-in-out py-2 px-5 sm:px-8 rounded-md">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6 items-center mr-2"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={2}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                  voir plus
                </button>
                <div
                  onClick={() =>
                    handleFavoriteClick(movie, movie.title)
                  }
                  className="text-white w-10 h-10 border-[2px] rounded-full p-2 mr-1 backdrop-blur-[1px] hover:bg-white hover:text-black shadow-md cursor-pointer ease-linear transition-all duration-150"
                >
                  {movie.isLiked ? (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="white"
                      viewBox="0 0 24 24"
                      strokeWidth={1.5}
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
                      />
                    </svg>
                  ) : (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth={1.5}
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
                      />
                    </svg>
                  )}
                </div>
              </>
            ) : (
              <>
                <button className="animate-pulse bg-neutral-900 transition duration-500 ease-in-out shadow-2xl flex items-center mb-3 mr-3 text-base sm:text-xl font-semibold text-neutral-500 py-2 sm:py-2 px-10 sm:px-14 rounded-md">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-5 items-center mr-2"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={2}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z"
                    />
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                  Regarder
                </button>

              </>
            )}
          </div>
        </div>
        <div
          style={{
            position: "absolute",
            bottom: "0px",
            width: "100%",
            height: "277px",
            transform: "matrix(1, 0, 0, 1, 0, 0)",
            background:
              "linear-gradient(rgba(25, 12, 41, 0) 0%, rgba(25, 12, 41, 0.714) 32%, rgba(25, 12, 41, 0.957) 75%, rgb(25, 12, 41) 100%)",
            opacity: 1,
          }}
          className="mt-auto"
        />

      </div>

      <>
        {/* Movie Pop Up section */}
        <AnimatePresence>
          {showModal && (
            moviePopupInfo.type === "series" ? <>
              <SeriePopup
                modalRef={modalRef}
                popupInfo={moviePopupInfo}
                playSerie={playSerie}
                playMovie={playMovie}
                handleFavoriteClick={handleFavoriteClick}
                setShowModal={setShowModal}
              />
              <div className="opacity-50 fixed inset-0 z-40 bg-gray-800"></div>
            </> :
              <>
                <ContentPopup
                  modalRef={modalRef}
                  popupInfo={moviePopupInfo}
                  playSerie={playSerie}
                  playMovie={playMovie}
                  handleFavoriteClick={handleFavoriteClick}
                  setShowModal={setShowModal}
                />
                <div className="opacity-50 fixed inset-0 z-40 bg-gray-800"></div>
              </>
          )}
        </AnimatePresence>

      </>

    </>
  );
}

export default Banner;
